import React, {useState} from 'react'
import {Button, message, notification} from 'antd'
import parseToken from "../../../../helpers/parseToken";
import {formatDateFromLocal} from "../../../../helpers/formatDate";
import {reportDetailFeeGGSheet} from "../../../../services/api/apiCustomerHub"

const Export = (props) => {
    const decodeToken = parseToken()
    const {filters} = props
    const [loadingE, setLoadingE] = useState(false)

    const _onExportGoogle = async () => {
        setLoadingE(true)

        try {
            const response = await reportDetailFeeGGSheet(decodeToken.sub, {
                fromDate: formatDateFromLocal(filters.fromDate),
                shortPhone: filters?.shortPhone,
                tenantId: filters?.tenantId,
                toDate: formatDateFromLocal(filters.toDate)
            })

            const {success, error_message} = response

            if (success !== '1') {
                setLoadingE(false)
                return message.error(error_message)
            }

            setLoadingE(false)
            notification.success({
                message: 'Export thành công',
                description: <div>
                    Export ra link thành công bạn có thể kiểm tra dữ liệu ở
                    <a href={error_message} target="_blank"  rel="noreferrer"> link</a>
                </div>,
                duration: 0
            })
        } catch (e) {
            setLoadingE(false)
            message.error(e.message)
        }
    }

    return <>
        <Button key="submit" type="primary" loading={loadingE} onClick={_onExportGoogle}>
            Export
        </Button>
    </>
}

export default Export
